import React, { useEffect, useState } from 'react'
import RadioInput from './RadioInput'

const RadioGroup = ({ options, onChange, selectedValue, setValue }) => {
    const [selectedOption, setSelectedOption] = useState(selectedValue);
    const handleChange = (value) => {
        setSelectedOption(value);
        setValue(value);
    };
      
    return (
        <div className="flex flex-col gap-2">
            {options.map((value) => (
                <RadioInput
                    key={value}
                    value={value}
                    checked={selectedOption === value}
                    onChange={handleChange}
                    setValue={setValue}
                />
            ))}
        </div>
    );
};

export default RadioGroup